<template>
     <div class="footer">
          Hi! I am <i>Jenuel Oras Ganawed</i> , I made this using VueJS with SASS. You can check about me 👉👉<a href="http://jenuelganawed.ml">CLICK ME</a>
     </div>
</template>
<script>
export default {
     name: "JFooter"
}
</script>